export default __webpack_public_path__ + "static/media/seedjar.2cb0801b.jpeg";